import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';

import {
	ADD_MAIN_CATEGORY,
	GET_ALL_CATEGORIES,

	REMOVE_MAIN_CATEGORY,
	REMOVE_SUB_CATEGORY,

	UPDATE_CATEGORY,
	UPDATE_CATEGORY_TITLE,
	UPDATE_GOOGLE_TAXONOMY,
	UPDATE_SUB_CATEGORY_IMAGE,
	UPDATE_SUB_CATEGORY_TITLE
} from '../actions/types';

const defaultCategoryState = {
	loading: false,
	data: false
};

export const categoryReducer = ( state = defaultCategoryState, action ) => {
	switch( action.type ){

		case ADD_MAIN_CATEGORY:
			return {
				loading: false,
				data: [
					action.category,
					...state.data
				]

			}

		case `${GET_ALL_CATEGORIES}_${PENDING}`:
			return {
				loading: true,
				data: state.data
			}

		case `${GET_ALL_CATEGORIES}_${FULFILLED}`:
			return {
				loading: false,
				data: action.payload.data.categories
			}

		case `${GET_ALL_CATEGORIES}_${REJECTED}`:
			return {
				loading: false,
				data: state.data
			}

		case REMOVE_MAIN_CATEGORY:
			return {
				...state,
				data: state.data.filter(
					mainCat => mainCat.titleUrl !== action.mainCategory.titleUrl
				)
			}

		case REMOVE_SUB_CATEGORY: 
			return {
				...state,
				data: state.data.map(
					mainCat => {
						if(mainCat.titleUrl === action.mainCategory.titleUrl){
							return {
								...mainCat,
								children: mainCat.children.filter(
									subCat => subCat.titleUrl !== action.subCategory.titleUrl
								)
							}
						}

						return mainCat;
					}
				)
			}
	
		case UPDATE_CATEGORY:

			const { category } = action;

			return {
				...state,
				data: [
					...state.data.map(
						_category => ((category._id === _category._id)?category:_category)
					)
				]
			}

		case UPDATE_CATEGORY_TITLE:
			
			let {mainIndex, value} = action;

			return {
				loading: false,
				data: state.data.map(
					(mainCat, i) => {
						
						if( i === mainIndex ){
							// mainCat
							return {
								...mainCat,
								title: value,
								edited: true
							};

						}

						return mainCat;
					}
				)
			}

		case UPDATE_GOOGLE_TAXONOMY:{

			let { mainIndex, subIndex, googleTaxonomy } = action;

			return {
				...state,
				data: state.data.map(
					( _mainCat, i ) => {

						if( i === mainIndex ){


							return {
								..._mainCat,
								children: _mainCat.children.map(
									( _subCat, j ) => {

										if( j === subIndex ){
											return {
												..._subCat,
												googleTaxonomy,
												edited: true
											}
										}

										return _subCat;

									}
								)
							}

						}

						return _mainCat;

					}
				)
			}

		}
		
		case UPDATE_SUB_CATEGORY_IMAGE: {

			let { mainIndex, subIndex, value } = action;
			
			return {
				loading: false,
				data: state.data.map(
					(mainCat, i) => {
						
						if( i === mainIndex ){
							// mainCat
							return {
								...mainCat,
								children: mainCat.children.map(
									(subCat, j) => {
	
										if( j === subIndex ){
											return {
												...subCat,
												image: value
											}
										}
	
										return subCat;
	
									}
								)
							};
	
						}
	
						return mainCat;
					}
				)
			}

		}
		
		case UPDATE_SUB_CATEGORY_TITLE: {

			let { mainIndex, subIndex, value } = action;
			
			return {
				loading: false,
				data: state.data.map(
					(mainCat, i) => {
						
						if( i === mainIndex ){
							// mainCat
							return {
								...mainCat,
								children: mainCat.children.map(
									(subCat, j) => {
	
										if( j === subIndex ){
											return {
												...subCat,
												title: value,
												edited: true
											}
										}
	
										return subCat;
	
									}
								)
							};
	
						}
	
						return mainCat;
					}
				)
			}

		}
			

		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/components/category/reducers/index.js